import React from 'react';
import SestExchangeHistoryAutoBottomSheet from '@di-shared/features/diag/exchange/history/bottom-sheet/auto/SestExchangeHistoryAutoBottomSheet';

function SestExchangeHistoryAutoBottomSheetPage() {
  const vin = window.data.vin as unknown as string;
  return (
    <SestExchangeHistoryAutoBottomSheet
      vin={vin}
      onExit={() => window.bottomSheetClose(null)}
    />
  );
}

export default SestExchangeHistoryAutoBottomSheetPage;
